<app-decision-modal
  #unsavedChangesModale8732te82j
  [details]="['You have unsaved changes. How would you like to proceed?']"
  [header]="header"
  [buttons]="decicionButtons"
  [decisionLevel]="decisionLevel"
  [yesNoButtons]="false"
  (decision)="onUnsavedChangesConfirmed($event)"
></app-decision-modal>
